export const slides = $("#new-player .slide") // :not(#loading-slide)
export const slideContainer = $("#slide-container")
export const slideImages = $("#new-player .slide-image")
export const firstImage = slideImages.first()
export const currentImage = $("#new-player .slide.current .slide-image")
export const playerNavcurrentSlideNumber = $("#new-player .current-slide-number")
export const stage = $("#new-player #stage")
export const progressBar = $("#progress-bar")
export const player = $("#new-player")
export const toolbar = $("#player-toolbar")
export const navigationPointers = $(".pointly")
export const fullscreenOverlay = $("#player-fullscreen-overlay")
export const nextSlideNavigation = $("#new-player #next-slide")
export const previousSlideNavigation = $("#new-player #previous-slide")
export const fullscreenOverlayNextSlide = $("#player-fullscreen-overlay #overlay-next-slide")
export const fullscreenOverlayPreviousSlide = $("#player-fullscreen-overlay #overlay-previous-slide")
export const cssFullscreenOverlayBackdrop = $("#fullscreen-css-backdrop")
export const interstitialAdOverlays = $("#new-player .slide .ad-overlay")
export const interstitialDismissButtons = $("#new-player .slide .ad-overlay .skip-ad-button")

export const getSlideSelectorByIndex = (index) => {
  return `#new-player #slide-${index}`
}

export const getSlideAdOverlayByIndex = (index) => {
  return $(`#new-player #slide-${index} .ad-overlay`)
}

export const TOOLBAR_HEIGHT = 50
export const SLIDE_MARGIN = 7
